import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import Modal from '../../../components/modal/index';
import PortalCommunication from '../../../portal-comms';
import { StudentManagement } from '../../../helpers/icon-dictionary';
import SvgIcon from '../../svg-icon/svg-icon';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import messages from '../messages';
import css from '../index.scss';

const SignInCardsEmptyState = (props) => {
    const { intl, selectedTeachersId, classesWithStudents } = props;

    return (
        <Modal show={!selectedTeachersId.length && !classesWithStudents}>
            <div className={css.emptyContainer}>
                <div className={css.emptyNotice}>
                    <div className={css.emptyState}>
                        <div className={css.emptyIconContainer}><SvgIcon icon={StudentManagement} /></div>
                    </div>
                    <div className={css.noResult}>{intl.formatMessage(messages.noStudentsAvailable)}</div>
                </div>
            </div>
            <div className={css.emptyStateFooter}>
                <Button
                    handleOnClick={() => { PortalCommunication.navigateToLandingScreen('School roll'); }}
                    label={intl.formatMessage(messages.ok)}
                    variant={DARK} />
            </div>
        </Modal>);
};

SignInCardsEmptyState.propTypes = {
    intl: intlShape.isRequired,
    selectedTeachersId: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    classesWithStudents: PropTypes.number
};

export default injectIntl(styleable(css)(SignInCardsEmptyState));



// WEBPACK FOOTER //
// ./app/components/sign-in-cards/modals/blank-state.js